<script>
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";

  export let title = "";
  export let submit = false;
  export let error = false;
  export let privacy = "";
  export let lang = "en";
  const dispatch = createEventDispatcher();

  function onAccept(checked) {
    error = false;
    dispatch("accept", { accepted: checked });
  }
</script>

<div class="card" transition:fade>
  <div class="checkbox-container">
    <label class="container">
      <input type="checkbox" on:change={(e) => onAccept(e.target.checked)} />
      {#if lang === "es"}
        Acepto la política de privacidad
        {#if submit}
          de <a
            class="privacy-link"
            target="_blank"
            rel="noopener"
            href="https://walink.io/es/politica-de-privacidad">Walink, Inc</a
          > y de
        {/if}
        <a
          class="privacy-link"
          href={/^(https?:|)\/\//.test(privacy) ? privacy : "//" + privacy}
          target="_blank"
          rel="noopener">{title}</a
        >
      {:else}
        I accept
        {#if submit}
          <a
            class="privacy-link"
            target="_blank"
            rel="noopener"
            href="https://walink.io/privacy-policy">Walink, Inc</a
          > and
        {/if}
        <a
          class="privacy-link"
          href={/^(https?:|)\/\//.test(privacy) ? privacy : "//" + privacy}
          target="_blank"
          rel="noopener">{title}</a
        >
        privacy policy.
      {/if}
      {#if submit}
        {lang === "es"
          ? `La información podrá ser almacenada para su uso futuro.`
          : `Information might be stored for later use.`}
      {/if}
      <span class="checkmark" />
    </label>
  </div>
  {#if error}
    <p class="error">
      {lang === "es"
        ? `Debes aceptar la política de privacidad`
        : `You must accept privacy policy`}
    </p>
  {/if}
</div>

<style>
  input {
    padding-top: 2px;
  }
  label {
    text-align: left;
  }
  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    width: 100%;
    max-width: 100%;
  }

  .card {
    border-radius: 15px;
    background-color: #fff;
    box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 8px 0px;
    padding: 1rem;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 400px;
    width: 90%;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-bottom: 0;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 5px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #333;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .error {
    color: #f75d59;
    margin-top: 0.5rem;
    margin-bottom: 0;
    font-size: 12px;
  }
  .privacy-link {
    /* margin-left: 5px; */
    font-weight: bold;
  }
</style>
